module.exports = __webpack_public_path__ + "img/wait_validation_icon.19d54087.svg";